import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { stringUtils } from '~/util';
import classNames from '~/components/util/classNames';

// import eye from './eye.svg';
// import eye_hide from './eye_hide.svg';
import './style.css';
import useForm from '~/hooks/useForm';

const FormPassword = ({
    label = '',
    name = stringUtils.kebab(label),
    placeholder = '',
    autoComplete = '',
    value = '',
    error = '',
    path = '',
    onChange,
    onBlur,
    validator,
    groupClassName,
    inputClassName,
    labelClassName,
    onSubmitAction,
    required
}) => {
    
    const hasError = !isEmpty(error);
    const {
        state,
        // fieldActions
    } = useForm({
        initialState: {
            showPassword: false,
        }
    });

    // let passwordIcon = state.values.showPassword ? eye_hide : eye;

    const hasErrorClass = hasError ? 'is-invalid' : '';
    const inputClasses = classNames('form-input', hasErrorClass, inputClassName);

    return (
        <div className={classNames('form-group', groupClassName)}>
            { label && <label htmlFor={name} className={classNames(labelClassName, 'form-label', required && 'required')}>{label}</label> }
            <div className="password">
                <input
                    id={name}
                    name={name}
                    type={state.values.showPassword ? 'text' : 'password'}
                    className={inputClasses}
                    placeholder={placeholder}
                    autoComplete={autoComplete}
                    value={value}
                    onChange={(event) => onChange(event.target.value, path)}
                    onBlur={event => onBlur && onBlur(event.target.value, path, validator)}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                            onSubmitAction();
                        }
                    }
                    }
                />
                <div className="invalid-feedback">
                    {error}
                </div>
                {/* <img 
                    src={passwordIcon} 
                    alt="" 
                    onClick={() => {
                        fieldActions.onChange(!state.values.showPassword, 'showPassword');
                    }
                    } 
                /> */}
            </div>
        </div>
    );
};

FormPassword.propTypes = {
    formError: PropTypes.object,
    label: PropTypes.string,
    name: PropTypes.string,
    path: PropTypes.string,
    placeholder: PropTypes.string,
    autoComplete: PropTypes.string,
    value: PropTypes.string,
    error: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    validator: PropTypes.func,
    onToggle: PropTypes.func,
    showPassword: PropTypes.func,
    groupClassName: PropTypes.string,
    inputClassName: PropTypes.string,
    labelClassName: PropTypes.string,
    required: PropTypes.bool,
    onSubmitAction: PropTypes.func,
};


export default FormPassword;